import type { IControl } from 'maplibre-gl'

export class HomeButtonControl implements IControl {
  private _container: HTMLDivElement | undefined
  private _onClick: () => void

  constructor(onClick: () => void) {
    this._onClick = onClick
  }

  onAdd(): HTMLElement {
    this._container = document.createElement('div')
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group'

    const button = document.createElement('button')
    button.className = 'maplibregl-ctrl-home'
    button.type = 'button'
    button.title = 'Overview'
    button.setAttribute('aria-label', 'Overview')
    button.innerHTML = '<svg viewBox="0 0 20 20" width="20" height="20" fill="currentColor"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/></svg>'
    button.addEventListener('click', this._onClick)

    this._container.appendChild(button)
    return this._container
  }

  onRemove(): void {
    this._container?.parentNode?.removeChild(this._container)
  }
}
